import { render, staticRenderFns } from "./QRCodeSettings.vue?vue&type=template&id=79880a24"
import script from "./QRCodeSettings.vue?vue&type=script&lang=js"
export * from "./QRCodeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports